module.exports = __webpack_public_path__ + "static/banner-93dd70d8c7c4fdb08f8f3668ba497ff5.png";